<template>
  <div class="content-editor-block video-youtube">

    <iframe v-if="isPreviewYoutube"
      :src="'https://www.youtube.com/embed/'+id"
      frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"></iframe>

    <el-input v-model="mValue" @input="onInput" placeholder="請輸入Youtube影片連結或影片ID"></el-input>

  </div>
</template>

<script>
import YoutubeLinkParser from '@/utils/YoutubeLinkParser.js'
export default {
  props: {
    value: {
      default: ''
    }
  },
  data: () => {
    return {
      mValue: '',
      timer: null,
      isPreviewYoutube: false
    }
  },
  computed: {
    id () {
      return YoutubeLinkParser.parse(this.mValue)
    }
  },
  methods: {
    onInput () {
      this.$emit('input', this.id)
      if (this.timer) clearTimeout(this.timer)
      if (this.mValue) this.timer = setTimeout(this.previewYoutube, 500)
      else this.previewYoutube()
    },
    previewYoutube () {
      this.isPreviewYoutube = Boolean(this.mValue)
    }
  },
  created () {
    this.mValue = this.value
    if (this.mValue) this.previewYoutube()
  },
  watch: {
    value () {
      this.mValue = this.value
    }
  }
}
</script>
